package models

import kotlinx.serialization.Serializable

@Serializable
data class Country(
    val iso: String? = null,
    val name: String? = null
)
